import apiUrl from '../../.././constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from '../shared/loader'
import Pagination from '../shared/pagination'
import pako from 'pako'
import FileSaver from 'file-saver'
import JSZip from 'jszip'

export default {
	name: 'historicalreport',
	components: {
	Pagination,
		DatePicker,
		download,
		Loader
	},

	data: function() {
		return {
			totalRows: 0,
			currentPage: 1,
			listRequestedReportData: [],
			listWarehouseData: [],
			listClientData: [],
			listRequestedreportNames: [],
			pageno: 0,
			limit: 10,
			totalPage: 0,
			isLoading: false,
			searchFlag: false,
			resultCount: '',
			clientsearch: '',
			warehousesearch: '',
			clientid: '',
			clientarr: [],
			warehouseid: '',
			warehousearr: [],
			generatedReportId: '',
			ClientErr: '',
			WarehouseErr: '',
			ReportErr: '',
			toDateErr: '',
			fromDateErr: '',
			snowFlakeMasterReportList: [],
			snowFlakeReportList: [],
			generateReportStatus: false,
			reportid: '',
			reportArr: [],
			currentGenerationreportId: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			showHistoricalReport: false,
			loaderForRequestedReports: false,
			user_type: '',
			username: '',
			userid: '',
			createdDate: '',
			transactionfromdate: moment().add(-30, 'days'),
			transactiontodate: moment()
		}
	},

	created: function() {},

	filters: {
		capitalize: function(value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	},

	async mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = this.userid = userdetail.userid;
		this.username = userdetail.fullname;
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				if (localStorage.getItem("selectedWarehouse")!=='undefined' && localStorage.getItem("selectedClient")!=='undefined')
				{
				await this.getClientList();
				await this.getWarehouseList();
				}
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.showSelectWarehouse = true;
				if (localStorage.getItem("selectedWarehouse")!=='undefined' && localStorage.getItem("selectedClient")!=='undefined')
				{
				await this.getWarehouseList();
				}
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				if (localStorage.getItem("selectedWarehouse")!=='undefined' && localStorage.getItem("selectedClient")!=='undefined')
				{
				await this.getClientList();
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break;
		}

		await this.getSnowFlakeReportsMaster();
	},

	methods: {
		getClientname(){
			this.client=localStorage.getItem("selectedClient")
			return this.clientarr[this.client]
		},
		getWarehousename()
		{
			this.warehouse=localStorage.getItem("selectedWarehouse")
			return this.warehousearr[this.warehouse]
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		sizeFormat(filesize, filesizeunit) {
			if (filesize / 1024 < 1024) {
				filesize = filesize / 1024;
				return (filesize.toFixed(2) + ' KB');
			} else if (filesize / (1024 * 1024) < 1024) {
				filesize = filesize / (1024 * 1024);
				return (filesize.toFixed(2) + ' MB');
			} else if (filesize / (1024 * 1024 * 1024) < 1024) {
				filesize = filesize / (1024 * 1024 * 1024);
				return (filesize.toFixed(2) + ' GB');
			} else {
				return (filesize.toFixed(2) + ' ' + filesizeunit);
			}
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('llll');
		},
		getSnowFlakeReportsMaster(){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'GET',
				'url': apiUrl.api_url + 'snowflakeReportMaster',
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.length > 0) {
						this.snowFlakeMasterReportList = result.data.data;
						for (let item in this.snowFlakeMasterReportList) {
							this.reportArr[this.snowFlakeMasterReportList[item].reportid] = this.snowFlakeMasterReportList[item].reportname;
						}
					} else {
						this.snowFlakeMasterReportList = [];
					}
				}, error => {
					console.error(error);
				});
		},
		onSearchSnowFlakeReports(){
			this.loaderForRequestedReports = true;
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.loaderForRequestedReports = false;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.loaderForRequestedReports = false;
				return false;
			}
			if (this.reportid == '') {
				this.ReportErr = this.$t('reports.selectReport');
				this.pageNo = this.totalPage = 0;
				this.loaderForRequestedReports = false;
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.limit,
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				userid: this.userid,
				reporttypeid: this.reportid
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'snowflakeReports',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			}).then((result) => {
					this.loaderForRequestedReports = false;
					if (result.data.count == 0) {
						this.resultCount = 0;
					} else {
						this.resultCount = result.data.data[0].total_count;
						this.snowFlakeReportList = result.data.data;
						this.totalRows = result.data.data[0].total_count;
						this.resultCount = result.data.data[0].total_count;
						console.log(this.totalRows,'totalRows');
						if (this.totalRows <this.limit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.limit);
						}
						console.log("totalPages", this.totalPage)
					}
					this.scrolldiv();
			}).catch((error) => {
				this.loaderForRequestedReports = false;
			})
		},
		onGenerateHistoricalReports(){
			this.snowFlakeReportList = [];
			this.totalPage = 0;
			this.showHistoricalReport = false;
			this.generateReportStatus= false;
			if (this.client == '') {
			    this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.isLoading = false;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.isLoading = false;
				return false;
			}
			if (this.reportid == '') {
				this.ReportErr = this.$t('reports.selectReport');
				this.pageNo = this.totalPage = 0;
				this.isLoading = false;
				return false;
			}
			var months;
			var fromDate = new Date(this.transactionfromdate);
			var ToDate = new Date(this.transactiontodate);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()));
			if (this.transactionfromdate == null || this.transactiontodate == null || months>3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var drto_date = '';
			var drfr_date = '';

			this.generateReportStatus = 'Processing';
			if (this.transactionfromdate) {
				drfr_date = this.dateFormat(this.transactionfromdate);
			}
			if (this.transactiontodate) {
				drto_date = this.dateFormat(this.transactiontodate);
			}
			this.createdDate = moment();
			this.input = ({
				clientid: this.client,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				userid: this.userid,
				fromdate: drfr_date,
				todate: drto_date,
				reporttypeid: this.reportid
			});
			this.currentGenerationreportId = this.reportid;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'generatesnowflakereport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.generateReportStatus = 'Download';
					if(result.data.data.status == "pending"){
					if(this.showHistoricalReport)
					{
						this.$alertify.error(this.$t('historicalReports.requestInProgress'));
					}
						this.generateReportStatus = 'Pending';
					}
					this.onSearchSnowFlakeReports();
					this.generatedReportId = result.data.data.id;
				}, error => {
					this.generateReportStatus = 'Failed';
					if(this.showHistoricalReport)
					{
						this.$alertify.error(this.$t('historicalReports.noFileGenerated'));
					}
					console.error(error);
				});
			this.showHistoricalReport = true;
		},
		onDownloadHistoricalReports(id){
			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input=({
				id: id,
				userid: this.userid
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'downloadRequestedReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				},
			})
				.then( response => {
					const zip = new JSZip();
					const result = pako.inflate(response.data.data.data);
					zip.file('Report.csv', result);
					zip.generateAsync({ type: 'blob' }).then(function (content) {
						FileSaver.saveAs(content, 'Reports.zip');
					});
					this.isLoading=false;
					// const blob = new Blob([result], {type: 'application/csv'});
					// const url = window.URL.createObjectURL(blob);
					// const link = document.createElement('a');
					// link.href = url;
					// link.setAttribute('download', 'Report.csv');
					// document.body.appendChild(link);
					// link.click();
  					// window.URL.revokeObjectURL(url);
					// this.isLoading = false;
				}, error => {
					this.isLoading = false;
					this.$alertify.error(this.$t('orders.failed'));
					console.error(error);
				});
		},
		getClientList() {
			this.snowFlakeReportList = [];
			this.totalPage = 0;
			this.showHistoricalReport = false;
			this.generateReportStatus= false;
			this.pageno = 0;
			if (window.localStorage.getItem("clientList") !== null) {
				var clientListEncrypt = window.localStorage.getItem('clientList');
				var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
				var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
				this.listClientData = JSON.parse(plaintextclient);
			} else {

				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.pageno = 0;

				this.input = ({
					warehouseid: localStorage.getItem("selectedWarehouse"),
				});

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
					.then(result => {
						this.listClientData = result.data.data;
					}, error => {
						console.error(error);
					});
			}
			if (this.listClientData.length > 0) {
				for (let item in this.listClientData) {
					this.clientarr[this.listClientData[item].clientid] = this.listClientData[item].clientname;
				}
			} else {
				this.clientarr = [];
			}
		},

		getWarehouseList() {
			this.snowFlakeReportList = [];
			this.totalPage = 0;
			this.showHistoricalReport = false;
			this.generateReportStatus= false;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listWarehouseData = result.data.data;
					this.warehouseid=localStorage.getItem("selectedWarehouse")
					if (this.listWarehouseData.length > 0) {
						for (let item in this.listWarehouseData) {
							this.warehousearr[this.listWarehouseData[item].warehouseid] = this.listWarehouseData[item].warehousename;
						}
					} else {
						this.warehousearr = [];
					}

				}, error => {
					console.error(error);
				});
		},

		// // client and warehouse
		// clientSelected() {
		// 	this.clientid = this.clientsearch;
		// 	this.warehousesearch = '';
		// 	this.reportid = '';
		// 	this.ClientErr= '',
		// 	this.WarehouseErr= '',
		// 	this.ReportErr= '',
		// 	this.toDateErr= '',
		// 	this.fromDateErr= '',
		// 	this.transactionfromdate= moment().add(-30, 'days'),
		// 	this.transactiontodate= moment(),
		// 	this.getWarehouseList();
		// },

		scrolldiv() {
			var elem = document.getElementById("ele");
			elem.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
		},
		// warehouseSelected() {
		// 	this.warehouseid = this.warehousesearch;
		// 		if (this.warehouseid) {
		// 			if (!this.clientid) {
		// 				this.getClientList();
		// 		}
		// 	}
		// },

		async resetForm() {
			this.totalRows= 0,
			this.currentPage= 1,
			this.pageno= 0,
			this.limit= 10,
			this.totalPage= 0,
			this.isLoading= false,
			this.searchFlag= false,
			this.resultCount= '',
			this.clientsearch= '',
			this.warehousesearch= '',
			this.clientid= '',
			this.warehouseid= '',
			this.generatedReportId= '',
			this.ClientErr= '',
			this.WarehouseErr= '',
			this.ReportErr= '',
			this.toDateErr= '',
			this.fromDateErr= '',
			this.snowFlakeMasterReportList= [],
			this.snowFlakeReportList= [],
			this.generateReportStatus= false,
			this.reportid= '',
			this.reportArr= [],
			this.currentGenerationreportId= '';
			if (this.user_type == 'warehouse_user')
          			{
						this.clientwr = '';
					}
				else if (this.user_type == 'client_user')
					{
						this.warehousewr = '';
					}
				else {
				this.clientwr = '';
				this.warehouwrse = '';
				this.showHistoricalReport= false;
				}
			this.createdDate= '',
			this.transactionfromdate= moment().add(-30, 'days'),
			this.transactiontodate= moment(),
			this.getSnowFlakeReportsMaster();
		},
		onPageChange(page) {
			this.currentPage = page;
			window.localStorage.setItem('currentPage', this.currentPage)
			this.onSearchSnowFlakeReports();
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/historicalreport/historicalreport.component.js